import Cookies from "js-cookie";
import React, { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
const Header = ({ onToggleSidebar, onCallFullScreen }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [notification, setNotification] = useState([]);
  const [selectedNotification, setSelectedNotification] = useState(null); // New state
  // console.log("selectedNotification", selectedNotification)
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [count, setCount] = useState(0);
  const gridRef = useRef();

  const navigate = useNavigate();
  const handleLogout = () => {
    Cookies.remove("token");
    Cookies.remove("logged_in");
    setTimeout(() => {
      toast.success("Logged out successfully!");
      navigate("/");
    }, 1000);
  };
  const getData = async () => {
    let BASE_URL = SERVER_URL + `/api/compliance/all-document/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data);
    // console.log("action",result.data.action)
    setNotification(result.data);
    // if(result.data.action === 0){

    setCount(result.data.length);

    // }
    // if (res.ok) {
    //   setRowData(result.data);
    // } else {

    // }
  };

  useEffect(() => {
    getData();
  }, []);

  const openModal = async (item) => {
    // console.log("id", item);
    setSelectedNotification(item);
  };

  const removeNotification = async (item) => {
    const id = item.id;
    let BASE_URL =
      SERVER_URL + `/api/compliance/update-notification/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: id,
      }),
    });
    const result = await res.json();
    if (res.ok) {
      getData();
    }
  };

  const closeNotification = async (item) => {
    const id = item.id;
    // console.log("id", id);
    let BASE_URL =
      SERVER_URL + `/api/compliance/update-notification/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: id,
      }),
    });
    const result = await res.json();
    if (res.ok) {
      getData();
    }
  };
  const shouldShowCount = notification.some((item) => item.action === 0);
  useEffect(() => {
    if (shouldShowCount) {
      const count = notification.filter((item) => item.action === 0).length;
      setCount(count);
    }
  }, [notification]); // Add dependency array to useEffect

  const formatTimeDifference = (sentOn) => {
    const now = moment();
    const notificationTime = moment(sentOn);
    const diffMinutes = now.diff(notificationTime, "minutes");

    if (diffMinutes < 1) {
      return "just now";
    } else if (diffMinutes < 60) {
      return `${diffMinutes} minute${diffMinutes !== 1 ? "s" : ""} ago`;
    } else if (diffMinutes > 60 && diffMinutes < 1440) {
      const diffHours = Math.floor(diffMinutes / 60);
      return `${diffHours} hour${diffHours !== 1 ? "s" : ""} ago`;
    } else {
      const diffDays = Math.floor(diffMinutes / 1440);
      return `${diffDays} day${diffDays !== 1 ? "s" : ""} ago`;
    }
  };
  const handleRefreshClick = (event) => {
    event.preventDefault(); // Prevent default behavior
    getData();
  };

  return (
    <>
      <nav className="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
        <div className="navbar-brand-wrapper d-flex justify-content-center">
          <div className="navbar-brand-inner-wrapper d-flex justify-content-between align-items-center w-100">
            <NavLink className="navbar-brand brand-logo" to="/dashboard">
              <img
                src="../../assets/images/kusum-logo-mini.png"
                alt="logo"
                style={{ objectFit: "contain" }}
              />
            </NavLink>
            <NavLink className="navbar-brand brand-logo-mini" to="/dashboard">
              <img
                src="../../assets/images/kusum-logo-mini.png"
                alt="logo"
                style={{ objectFit: "contain" }}
              />
            </NavLink>
            <button
              className="navbar-toggler navbar-toggler align-self-center"
              type="button"
              data-toggle="minimize"
              onClick={onToggleSidebar}
            >
              <span className="mdi mdi-sort-variant" />
            </button>
          </div>
        </div>
        <div className="navbar-menu-wrapper d-flex align-items-center justify-content-end">
          <ul className="navbar-nav mr-lg-4 w-100">
            {/* <li className="nav-item nav-search d-none d-lg-block w-100">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="search">
                                        <i className="mdi mdi-magnify" />
                                    </span>
                                </div>
                                <input type="text" className="form-control" placeholder="Search now" aria-label="search" aria-describedby="search" />
                            </div>
                        </li> */}
          </ul>
          <ul className="navbar-nav navbar-nav-right">
            <button
              className="btn btn-light"
              title={
                onCallFullScreen?.active ? "Exit full screen" : "Full Screen"
              }
              onClick={() => {
                try {
                  onCallFullScreen?.active
                    ? onCallFullScreen.exit()
                    : onCallFullScreen.enter();
                } catch (error) {
                  console.error("Error handling full screen mode", error);
                }
              }}
            >
              <span>
                <i
                  className={
                    onCallFullScreen?.active
                      ? "mdi mdi-fullscreen-exit"
                      : "mdi mdi-fullscreen"
                  }
                />
              </span>
            </button>
            {/* <li className="nav-item dropdown mr-1">
                            <a className="nav-link count-indicator dropdown-toggle d-flex justify-content-center align-items-center" id="messageDropdown" href="#" data-toggle="dropdown">
                                <i className="mdi mdi-message-text mx-0" />
                                <span className="count" />
                            </a>
                            <div className="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="messageDropdown">
                                <p className="mb-0 font-weight-normal float-left dropdown-header">Messages</p>
                                <a className="dropdown-item">
                                    <div className="item-thumbnail">
                                        <img src="images/faces/face4.jpg" alt="image" className="profile-pic" />
                                    </div>
                                    <div className="item-content flex-grow">
                                        <h6 className="ellipsis font-weight-normal">David Grey
                                        </h6>
                                        <p className="font-weight-light small-text text-muted mb-0">
                                            The meeting is cancelled
                                        </p>
                                    </div>
                                </a>
                                <a className="dropdown-item">
                                    <div className="item-thumbnail">
                                        <img src="images/faces/face2.jpg" alt="image" className="profile-pic" />
                                    </div>
                                    <div className="item-content flex-grow">
                                        <h6 className="ellipsis font-weight-normal">Tim Cook
                                        </h6>
                                        <p className="font-weight-light small-text text-muted mb-0">
                                            New product launch
                                        </p>
                                    </div>
                                </a>
                                <a className="dropdown-item">
                                    <div className="item-thumbnail">
                                        <img src="images/faces/face3.jpg" alt="image" className="profile-pic" />
                                    </div>
                                    <div className="item-content flex-grow">
                                        <h6 className="ellipsis font-weight-normal"> Johnson
                                        </h6>
                                        <p className="font-weight-light small-text text-muted mb-0">
                                            Upcoming board meeting
                                        </p>
                                    </div>
                                </a>
                            </div>
                        </li> */}
            <li className="nav-item dropdown mr-4">
              <a
                className="nav-link count-indicator dropdown-toggle d-flex align-items-center justify-content-center notification-dropdown"
                id="notificationDropdown"
                href="#"
                data-toggle="dropdown"
              >
                <i className="mdi mdi-bell mx-0" />
                {shouldShowCount && <span className="count ml-1">{count}</span>}
              </a>
              <div
                className="dropdown-menu dropdown-menu-right navbar-dropdown"
                aria-labelledby="notificationDropdown"
              >
                {/* <p className="mb-0 font-weight-normal float-left dropdown-header notification-dropdown-header">
                    Notifications
                  </p> */}

                <button
                  className="btn btn-sm btn-light btn-icon-text border ml-1"
                  onClick={handleRefreshClick}
                >
                  <i
                    className="mdi mdi-refresh"
                    style={{ height: "4px", width: "4px" }}
                  ></i>
                </button>
                <hr />
                {shouldShowCount == false ? (
                  <p className="mb-0 font-weight-normal float-left dropdown-header notification-dropdown-header">
                    Notifications is empty
                  </p>
                ) : (
                  notification &&
                  notification?.length > 0 &&
                  notification?.map((item, index) => {
                    const formattedDate = moment(item.sent_on).format(
                      "DD-MM-YYYY"
                    );
                    const timeDifference = formatTimeDifference(item.sent_on);
                    return (
                      <>
                        {item.action === 0 ? (
                          <a
                            className="dropdown-item notification-item"
                            key={index}
                            onClick={() => openModal(item)}
                          >
                            <div className="item-thumbnail">
                              <div className="item-icon notification-icon">
                                <i className="mdi mdi-information mx-0" />
                              </div>
                            </div>
                            <div
                              className="item-content"
                              data-toggle="modal"
                              data-target="#largeModal"
                            >
                              <a className="font-weight-bold">
                                {item.doc_name}
                              </a>
                              <p className="font-weight-light small-text mb-0 text-muted">
                                {formattedDate} ({timeDifference})
                              </p>
                            </div>

                            <button
                              className="close"
                              onClick={() => removeNotification(item)}
                            >
                              <span className="mdi mdi-close pl-3"></span>
                            </button>
                          </a>
                        ) : (
                          ""
                        )}
                      </>
                    );
                  })
                )}
              </div>
            </li>
            <li className="nav-item nav-profile dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                data-toggle="dropdown"
                id="profileDropdown"
              >
                <span className="nav-profile-name">Kusum Industries</span>
              </a>
              <div
                className="dropdown-menu dropdown-menu-right navbar-dropdown"
                aria-labelledby="profileDropdown"
              >
                <NavLink
                  className="dropdown-item"
                  to="/adduser"
                  style={{ textDecoration: "none" }}
                >
                  <i className="mdi mdi-account text-primary" />
                  Add User
                </NavLink>
                <a className="dropdown-item" onClick={handleLogout}>
                  <i className="mdi mdi-logout text-primary" />
                  Logout
                </a>
              </div>
            </li>
          </ul>
          <button
            className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
            type="button"
            data-toggle="offcanvas"
            onClick={onToggleSidebar}
          >
            <span className="mdi mdi-menu" />
          </button>
        </div>
      </nav>

      <div
        className="modal fade"
        id="largeModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="basicModal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header notification-modal-header">
              <h5 className="modal-title " id="myModalLabel">
                {selectedNotification && selectedNotification.doc_name} Renewal
                Notification
              </h5>
              {/* <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => setSelectedNotification(null)}>
                <span aria-hidden="true">&times;</span>
              </button> */}
            </div>
            <div className="modal-body notification-modal-body">
              <h5
                dangerouslySetInnerHTML={{
                  __html:
                    selectedNotification && selectedNotification.description,
                }}
              ></h5>
            </div>
            <div className="modal-logo">
              <img src="../../assets/images/kusum-logo.png" alt="" />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
                onClick={() => closeNotification(selectedNotification)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
